import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'hooks/apollo';
import { Tooltip } from '@mui/material';
import { EXPORT_APPROVAL_TYPE_LIST } from '../mutations';
import { APPROVAL_TYPES_FILTERS_QUERY } from '../queries';
import { buildExportDownloadUrl } from 'features/downloadList/api';
import { CloudDownload } from '@mui/icons-material';
import { fileType } from 'constants/fileTypes';
import { useSimpleError } from 'hooks/apolloWrappers';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { convertBase64ToFile } from 'utils/base64FileConversion';
import saveAs from 'file-saver';
import { IconButton } from '@totalsoft/rocket-ui';
import { getOidcConfigName } from 'utils/functions';
import { useOidcAccessToken } from '@axa-fr/react-oidc';

const ExportAction = () => {
  const [t] = useTranslation();
  const showError = useSimpleError();
  const [filters, setFilters] = useState({});
  const { accessToken } = useOidcAccessToken(getOidcConfigName());

  const [exportAnchorEl, setShowHandleClose] = useState(null);
  const isExportOpen = Boolean(exportAnchorEl);

  const [exportApprovalTypeList] = useMutation(EXPORT_APPROVAL_TYPE_LIST, {
    onCompleted: async ({ exportApprovalTypeList }) => {
      let downloadLink = null;
      try {
        if (exportApprovalTypeList.fileBytes) {
          saveAs(convertBase64ToFile(exportApprovalTypeList.fileBytes), exportApprovalTypeList.fileName);
          return;
        }
        downloadLink = await buildExportDownloadUrl(exportApprovalTypeList.filePath, exportApprovalTypeList.fileName, accessToken);
      } catch (error) {
        showError(error);
      }
      if (downloadLink) {
        window.location.href = downloadLink;
      }
    }
  });

  useQuery(APPROVAL_TYPES_FILTERS_QUERY, {
    onCompleted: data => {
      if (data)
        setFilters({
          approvalTypeName: data.approvalTypeListFilters.approvalTypeName.value,
          approvalTypeCode: data.approvalTypeListFilters.approvalTypeCode.value,
          fullTextFilter: data.approvalTypeListFilters.fullTextFilter.value
        });
    }
  });

  const onExport = filters => {
    exportApprovalTypeList({ variables: { filters } });
  };

  const handleExportClose = () => {
    setShowHandleClose(null);
  };

  const handleExportClick = event => {
    setShowHandleClose(event.currentTarget);
  };

  const handleExport = (fileType, filters) => () => {
    onExport({ ...filters, fileType });
    setShowHandleClose(null);
  };

  return (
    <>
      <Tooltip placement='top' title={t('Tooltips.DownloadApprovalTypeList')}>
        <div>
          <IconButton color='primary' onClick={handleExportClick}>
            <CloudDownload />
          </IconButton>
          <Menu id='render-export-menu' anchorEl={exportAnchorEl} open={isExportOpen} onClose={handleExportClose}>
            <MenuItem onClick={handleExport(fileType.excel, filters)}>{t('Export.Excel')}</MenuItem>
            <MenuItem onClick={handleExport(fileType.csv, filters)}>{t('Export.CSV')}</MenuItem>
          </Menu>
        </div>
      </Tooltip>
    </>
  );
};

export default ExportAction;
